export enum SeriesGenresEnum {
  action = "Action",
  adventure = "Adventure",
  animation = "Animation",
  biography = "Biography",
  comedy = "Comedy",
  crime = "Crime",
  documentary = "Documentary",
  drama = "Drama",
  family = "Family",
  fantasy = "Fantasy",
  "film-noir" = "Film-Noir",
  history = "History",
  horror = "Horror",
  music = "Music",
  musical = "Musical",
  mystery = "Mystery",
  romance = "Romance",
  "sci-fi" = "Sci-Fi",
  "short-film" = "Short-Film",
  sport = "Sport",
  superhero = "Superhero",
  thriller = "Thriller",
  war = "War",
  western = "Western",
  "based-on-real-story" = "Based on Real Story",
  legal = "Legal",
  finance = "Finance",
  espionage = "Espionage",
  political = "Political"
}